import { windowSize } from "./../windowSize";
import { gsap } from "gsap";
import { Global } from "./../global";
import { LineModal } from "./../_click/lineModal";
import { Ease } from "./../_ease/ease";
// import { easeOutExpo, easeInOutExpo, easeOutQuart,easeInOutQuart,easeInOutQuad } from 'easing-utils';
// import { easeInOutExpo } from 'easing-utils';

export const TopSnowAnimation = {
  canvas:null,
  context:null,
  xAxis:0,
  yAxis:0,
  unit:100,
  amp:0,
  color: "#FFFFFF",
  drawin:{},
  timer:null,
  moveInTimer:null,
  moveOutTimer:null,
  inc:0,
  intoScreen:false,
  imgLen:null,
  imgElem:null,
  logoElem:null,
  imgCurrent:null,
  isResizeOkay:true,
  // incVal: 0.005,
  setCanvas:(tgt)=>{
    TopSnowAnimation.frameBlur=document.querySelector('.frame-inner')
    // 画像
    TopSnowAnimation.logoElem=document.querySelectorAll('.logo-item')
    // TopSnowAnimation.logoElemMask=document.querySelectorAll('.logo-mask')
    TopSnowAnimation.bgImages()
    TopSnowAnimation.elemInit()
    // cvs
    TopSnowAnimation.canvas = document.getElementById(tgt);
    TopSnowAnimation.setCanvasSize()
    TopSnowAnimation.context = TopSnowAnimation.canvas.getContext("2d");
    TopSnowAnimation.adjustH = (Global.isMobile) ? 80 : 50;
    
    TopSnowAnimation.reset()
    if(!Global.isTopMvResizeListner){
      Global.isTopMvResizeListner=true;
      TopSnowAnimation.resize();
    }
    TopSnowAnimation.drawWhite()
  },
  ready:()=>{
    if(Global.isTopMvTimerActive){
      TopSnowAnimation.moveOut()
      TopSnowAnimation.draw()
    }
  },
  initialize:()=>{
    TopSnowAnimation.reset()
    TopSnowAnimation.drawWhite()
    cancelAnimationFrame(TopSnowAnimation.reqIn)
    cancelAnimationFrame(TopSnowAnimation.reqOut)
    clearTimeout(TopSnowAnimation.timer)
    clearTimeout(TopSnowAnimation.slidehandleTimer)
    TopSnowAnimation.intoScreen=false;
    TopSnowAnimation.imgElem.forEach(function(el){el.classList.remove('is-active')})
    TopSnowAnimation.logoElem.forEach(function(el){el.classList.remove('is-active')})
    TopSnowAnimation.frameBlur.classList.add('is-active');
    TopSnowAnimation.elemInit() 
  },
  elemInit:()=>{
    TopSnowAnimation.logoElem[0].classList.add('is-active');
    TopSnowAnimation.imgElem[0].classList.add('is-active');
  },
  bgImages:()=>{
    let img=document.querySelectorAll('.bg-item');
    TopSnowAnimation.imgLen=img.length;
    TopSnowAnimation.imgElem=img;
    TopSnowAnimation.imgCurrent=0;
  },
  reset:()=>{
    TopSnowAnimation.xAxis = Math.floor(TopSnowAnimation.canvas.height/4);
    TopSnowAnimation.amp=0
    TopSnowAnimation.yAxis = 0;
    TopSnowAnimation.drawin.t=0;
    TopSnowAnimation.drawin.seconds=0;
    TopSnowAnimation.inc=0

    
  },
  moveOut:()=>{
    let time=7000;
    let start=null;
    let ease = Ease.getEase("easeInOutExpo"); //easeInOutExpo
    let progress = 0;
    let easeProgress = 0;
    let isScale=true;

    let update = (timestamp) => {
      if (!start) start = timestamp;
      progress = (timestamp - start) / time;
      progress = Math.min(progress, 1);

      if (progress >= 0) {
        easeProgress = ease(progress, 0, 1, 1); // 進捗率からイージング関数を通した変化割合を算出
      }

      TopSnowAnimation.amp = 120*easeProgress;
      TopSnowAnimation.inc = (TopSnowAnimation.canvas.height+TopSnowAnimation.adjustH)*easeProgress;
    
      if(progress > 0.7 && isScale==true){
        isScale=false;
        TopSnowAnimation.logoElem.forEach(function(el){
          el.classList.remove('is-active')
        })
        gsap.to(TopSnowAnimation.imgElem[TopSnowAnimation.imgCurrent],7,{ease:"Power.easeInOut",scale: 1.05 });
        TopSnowAnimation.frameBlur.classList.remove('is-active');
        // gsap.to(TopSnowAnimation.logoElemMask[TopSnowAnimation.imgCurrent],7,{ease:"Power.easeInOut",scale: 1.05});
      }
      
      if (progress < 1) {
        TopSnowAnimation.reqOut=requestAnimationFrame(update);
      }
      else{
        cancelAnimationFrame(TopSnowAnimation.reqOut)
        clearTimeout(TopSnowAnimation.timer)

        if(Global.isLineModal){
          LineModal.fadeIn()
        }
        TopSnowAnimation.reset()
        TopSnowAnimation.slidehandle()
        TopSnowAnimation.isResizeOkay=false
        
      } 
    }
    let go =()=>{
      start=null;
      TopSnowAnimation.reqOut=requestAnimationFrame(update);
    }
    go()
  },
  moveIn:()=>{
    let time=7000;
    let start=null;
    let ease = Ease.getEase("easeInOutExpo"); //easeInOutExpo
    let progress = 0;
    let easeProgress = 0;

    let update = (timestamp) => {
      if(!start) start = timestamp;
      progress = (timestamp - start) / time;
      progress = Math.min(progress, 1);

      if (progress >= 0) {
        easeProgress = ease(progress, 0, 1, 1); // 進捗率からイージング関数を通した変化割合を算出
      }

      TopSnowAnimation.amp = 80*easeProgress;
      TopSnowAnimation.inc = (TopSnowAnimation.canvas.height+50)*easeProgress;
      
      if(progress > 0.53){
        TopSnowAnimation.logoElem[TopSnowAnimation.imgCurrent].classList.add('is-active')
        
      }
      if (progress < 0.7) {
        TopSnowAnimation.reqIn=requestAnimationFrame(update);
         
      }
      else{
        cancelAnimationFrame(TopSnowAnimation.reqIn)
        clearTimeout(TopSnowAnimation.timer)

        TopSnowAnimation.reset()
        TopSnowAnimation.intoScreen=false
        TopSnowAnimation.slideUpdate();
        TopSnowAnimation.frameBlur.classList.add('is-active');
        
      } 
    }
    let go =()=>{
      start=null;
      TopSnowAnimation.reqOut=requestAnimationFrame(update);
    }
    go()
    TopSnowAnimation.isResizeOkay=true
  },
  draw:()=>{
    TopSnowAnimation.clear()
    TopSnowAnimation.drawWave(TopSnowAnimation.color, 1, 3);
    TopSnowAnimation.drawin.seconds = TopSnowAnimation.drawin.seconds + .01;
    TopSnowAnimation.drawin.t = TopSnowAnimation.drawin.seconds*Math.PI; // Math.PIである必要なし

    TopSnowAnimation.timer = setTimeout(()=>{
      TopSnowAnimation.draw()
    }, 48)
    
  },
  drawWave:(color, alpha, zoom)=>{
    TopSnowAnimation.design(color,alpha)
    TopSnowAnimation.context.beginPath(); 

    if(TopSnowAnimation.intoScreen){
      TopSnowAnimation.drawWaveIn(zoom);
    }
    else{
      TopSnowAnimation.drawWaveOut(zoom);
    }
    
    // wave complete
    TopSnowAnimation.context.closePath() //パスを閉じる
    TopSnowAnimation.context.fill(); //塗りつぶす
  },
  design:(color,alpha)=>{
    TopSnowAnimation.context.fillStyle = color;
    TopSnowAnimation.context.globalAlpha = alpha;
  },
  drawWaveIn:(zoom)=>{
    let T=TopSnowAnimation.drawin.t;
    let x = T / 0.5; //時間を横の位置とする
    TopSnowAnimation.context.moveTo(0,0)

    // 下端の位置(x,y)　画面幅分 →　波を形成
    for (let i = 0,li=TopSnowAnimation.canvas.width+10; i <= li; i += 10) {
      // x = T+(-TopSnowAnimation.yAxis+i)/100/zoom;
      x = T+i/100/zoom;
      // y = TopSnowAnimation.amp*Math.sin(x);
      // ↓の100も変数にしてincにくみこみちあ
      TopSnowAnimation.context.lineTo(i, TopSnowAnimation.amp*Math.sin(x)+TopSnowAnimation.inc);
    }
    // Canvas右上
    TopSnowAnimation.context.lineTo(TopSnowAnimation.canvas.width + 10, 0); 
  },
  drawWaveOut:(zoom)=>{
    let T=TopSnowAnimation.drawin.t;
    let x = T / 0.5; //時間を横の位置とする
    for (let i = 0,li=TopSnowAnimation.canvas.width+10; i <= li; i += 10) {
      // x = T+(-TopSnowAnimation.yAxis+i)/100/zoom;
      x = T+i/100/zoom;
      // y = TopSnowAnimation.amp*Math.sin(x);

      TopSnowAnimation.context.lineTo(i, TopSnowAnimation.amp*Math.sin(x)+TopSnowAnimation.inc);
    }
    TopSnowAnimation.context.lineTo(TopSnowAnimation.canvas.width + 10, TopSnowAnimation.canvas.height);
    TopSnowAnimation.context.lineTo(0, TopSnowAnimation.canvas.height); 
  },
  clear:()=>{
    TopSnowAnimation.context.clearRect(0, 0, TopSnowAnimation.canvas.width, TopSnowAnimation.canvas.height);
  },
  setCanvasSize: ()=>{
    TopSnowAnimation.canvas.width=windowSize.clientSize().W;
    TopSnowAnimation.canvas.height=windowSize.clientSize().H;
  },
  drawWhite:()=>{
    TopSnowAnimation.clear();
    TopSnowAnimation.design("#FFF",1)
    TopSnowAnimation.context.beginPath(); 
    TopSnowAnimation.context.lineTo(0, 0);
    TopSnowAnimation.context.lineTo(TopSnowAnimation.canvas.width + 10, 0);
    TopSnowAnimation.context.lineTo(TopSnowAnimation.canvas.width + 10, TopSnowAnimation.canvas.height);
    TopSnowAnimation.context.lineTo(0, TopSnowAnimation.canvas.height)
    TopSnowAnimation.context.closePath() //パスを閉じる
    TopSnowAnimation.context.fill();
  },
  slidehandle:()=>{
    // 画像zoomアニメーション
    TopSnowAnimation.slidehandleTimer=setTimeout(()=>{
      TopSnowAnimation.intoScreen=true
      TopSnowAnimation.draw();
      TopSnowAnimation.moveIn();
      TopSnowAnimation.imgCurrent++
      if(TopSnowAnimation.imgCurrent>=TopSnowAnimation.imgLen){
        TopSnowAnimation.imgCurrent=0
      }
    },2000)
  },
  slideUpdate:()=>{
    TopSnowAnimation.imgElemActiveRemove();
    // TopSnowAnimation.logoElem.forEach(function(el){
    //   el.classList.remove('is-active')
    // })
    TopSnowAnimation.imgElem[TopSnowAnimation.imgCurrent].classList.add('is-active')
    // TopSnowAnimation.logoElem[TopSnowAnimation.imgCurrent].classList.add('is-active') 

    gsap.set(TopSnowAnimation.imgElem,{delay:1,scale: 1});
    // gsap.set(TopSnowAnimation.logoElemMask,{delay:1,scale: 1});
    TopSnowAnimation.draw()
    TopSnowAnimation.moveOut()
  },
  imgElemActiveRemove:()=>{
    TopSnowAnimation.imgElem.forEach(function(el){
      el.classList.remove('is-active')
    })
  },
  ieSlide:()=>{
    TopSnowAnimation.bgImages()
    TopSnowAnimation.imgElemActiveRemove()
    TopSnowAnimation.imgElem[0].classList.add('is-active')

    gsap.to('.canvas-container',.8,{autoAlpha:0})
    setInterval(()=>{
      TopSnowAnimation.imgCurrent++
      if(TopSnowAnimation.imgCurrent>=TopSnowAnimation.imgLen){
        TopSnowAnimation.imgCurrent=0
      }
      TopSnowAnimation.imgElemActiveRemove()
      TopSnowAnimation.imgElem[TopSnowAnimation.imgCurrent].classList.add('is-active')
    },6000);
  },
  resize:()=>{
    let setTimeoutId = null;
    window.addEventListener("resize", e => {
      if (setTimeoutId) clearTimeout(setTimeoutId);
      setTimeoutId = setTimeout(() => {
        TopSnowAnimation.setCanvasSize()
        if(TopSnowAnimation.isResizeOkay){
          TopSnowAnimation.drawWhite()
        }
        setTimeoutId = null;
      }, 50);
    });
  },
};
